import Modal from "global/component/Genericos/Modal/Modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import ConsultaIcon from "_+_Portal/assets/images/generico/ConsultaIcon";
import CorazonIcon from "_+_Portal/assets/images/generico/CorazonIcon";
import TestPcrIcon from "_+_Portal/assets/images/generico/TestPcrIcon";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BtnContainer,
  ContainerNecesitoTurno,
  TextNecesitoTurno,
} from "./localStyle";
import camelize from "global/utils/camelize";
import { useHistory } from "react-router";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { motion } from "framer-motion";

const NecesitoTurno = () => {
  // -------------------------  context ----------------------------
  const { pasoDispatch } = useContext(AutocheckContext);
  const { modalState, authState } = useContext(GlobalContext);
  const { selectDropDownState } = useContext(PortalContext);
  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------
  let config = localStorage.getItem("config");
  let opcAutoCheckInLabo = JSON.parse(config).opcAutoCheckInLabo;
  let opcAtencionSinTurnoPrevio = JSON.parse(config).opcAtencionSinTurnoPrevio;
  const pacienteNombre = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.nombre
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.nombre
    : authState.auth.data.paciente.nombre;
  const history = useHistory();

  // -------------------------  constantes ----------------------------

  const handleOnclick = (path) => {
    if (path === "CONSULTA") {
      setPaso("TipoTurnoConsulta")(pasoDispatch);
    } else if (path === "ESTUDIO") {
      history.push("/estudios");
    } else if (path === "LABO") {
      history.push("/laboratorio");
    }
  };

  const atencionSinTurnoPrevio = () => {
    setPaso("AtencionSinTurnoSelect")(pasoDispatch);
  };

  return (
    <>
      {modalState.modal.show && <Modal />}
      <LayoutPasos
        title={"Necesito turno"}
        subtitle={camelize("Para: " + pacienteNombre)}
      >
        <ContainerNecesitoTurno
          initial="hidden"
          animate="show"
          variants={containerVariants}
        >
          <TextNecesitoTurno>
            <span className="title-saludo">
              <span className="title-negrita">¿Que turno estas buscando?</span>
            </span>
          </TextNecesitoTurno>
          <BtnContainer>
            <motion.div variants={itemVariants}>
              <BtnLink
                Icon={<ConsultaIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"CONSULTA MÉDICA"}
                onclick={() => handleOnclick("CONSULTA")}
              />
            </motion.div>
            <motion.div variants={itemVariants}>
              <BtnLink
                Icon={<CorazonIcon color={"var(--color-primary)"} />}
                type={"NORMAL"}
                title={"ESTUDIO"}
                onclick={() => handleOnclick("ESTUDIO")}
              />
            </motion.div>
            {opcAutoCheckInLabo && (
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<TestPcrIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"LABORATORIO"}
                  onclick={() => handleOnclick("LABO")}
                />
              </motion.div>
            )}
            {/* {opcAtencionSinTurnoPrevio && (
              <BtnLink
                Icon={<LaboratorioIcon color={"var(--color-primary)"} />}
                title={"ATENCIÓN SIN TURNO PREVIO"}
                type="NORMAL"
                onclick={atencionSinTurnoPrevio}
              />
            )} */}
          </BtnContainer>
        </ContainerNecesitoTurno>
      </LayoutPasos>
    </>
  );
};

export default NecesitoTurno;
